import * as React from "react";
import { ExclusiveBrands, ExclusiveBrandsItem } from "@grandvisionhq/content";
import { Heading } from "@grandvisionhq/elements";
import { compose } from "@grandvisionhq/utils";
import { withBreakpointVisibility } from "../../../../hocs/hocs/with-breakpoint-visibility.js";
import { withHidableContent } from "../../../../hocs/hocs/with-hidable-content.js";
import { withBloomreachPageable } from "../../../../hocs/hocs/with-bloomreach-pageable.js";
import { withAnchor } from "../../../../hocs/hocs/with-anchor.js";
import { withEditableContent } from "../../../../hocs/hocs/with-editable-content.js";
import { useBloomreachLinks } from "../../../../hooks/hooks/use-bloomreach-links.js";
import { parseBloomreachImage } from "../../../../utils/utils/parse-bloomreach-image.js";
const CmsExclusiveBrandsItem = withEditableContent(({ content }) => {
  const [link] = useBloomreachLinks([{ url: content.url }]);
  const image = parseBloomreachImage(content.brandLogo);
  if (!image) {
    return null;
  }
  const originalImage = { ...image.original, alt: content.title };
  const mobileImage = { ...image.mobile, alt: content.title };
  return /* @__PURE__ */ React.createElement(ExclusiveBrandsItem, { url: link.url, image: originalImage, mobileImage });
});
const CmsBrandCollection = ({ content, template }) => {
  switch (template) {
    case "exclusive-brands":
      return /* @__PURE__ */ React.createElement(ExclusiveBrands, null, content.items.map((brand) => /* @__PURE__ */ React.createElement(CmsExclusiveBrandsItem, { key: brand.id, content: brand })));
    default:
      return /* @__PURE__ */ React.createElement(Heading, { variant: "subheading1" }, "Banner of type ", template, " not defined in BrandCollection");
  }
};
const BrandCollection = compose(
  withBreakpointVisibility,
  withHidableContent,
  withBloomreachPageable,
  withAnchor
)(CmsBrandCollection);
export {
  CmsBrandCollection,
  BrandCollection as default
};
//# sourceMappingURL=BrandCollection.js.map
